<template>
  <AppDialog
    v-model:open="open"
    :title="
      t(followup ? 'nkf.promptDetails.readingFollowup' : 'nkf.promptDetails.reading', {
        measurement,
      })
    "
    :description="
      t(
        followup
          ? 'nkf.promptDetails.readingFollowupDescription'
          : 'nkf.promptDetails.readingDescription',
        {
          measurement,
          time: DateUtils.formatTime(time),
          later: DateUtils.formatTime(DateUtils.getCurrentUserTimeZoneTime('HH:mm')),
        },
      )
    "
  >
    <template #illustration
      ><AppDialogIllustration
        src="/images/nkf/mo_bell.webp"
        background="var(--surface-navigation-violet)"
        width="62%"
    /></template>
    <AppDialogNote :icon="followup ? 'bell' : 'info'" :tone="followup ? 'warning' : 'info'">{{
      followup ? t('nkf.promptDetails.lastReminder') : t('nkf.promptDetails.sameTime')
    }}</AppDialogNote>
    <template #footer
      ><Button @click="record"
        ><AppIcon size="action" name="scale" />{{ t('nkf.promptDetails.recordReading') }}</Button
      ></template
    >
  </AppDialog>
</template>
<script setup>
// 1. Import necessary components
import DateUtils from '@/shared/utilities/date-utils';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { REMINDER_TYPE_OPTIONS } from '@/features/resources/constants/reminder';
import { useRouter } from 'vue-router';
import AppDialog from '@/shared/components/AppDialog.vue';
import AppDialogIllustration from '@/shared/components/AppDialogIllustration.vue';
import AppDialogNote from '@/shared/components/AppDialogNote.vue';
import AppIcon from '@/shared/components/AppIcon.vue';
import { Button } from '@/shared/components/ui/button';
// 2. Use
const open = defineModel('open', { type: Boolean, default: false });
const props = defineProps({
  type: { type: String, required: true },
  followup: { type: Boolean, default: false },
  time: { type: String, required: true },
});
const { t } = useI18n();
const router = useRouter();
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
const measurement = computed(() =>
  t(REMINDER_TYPE_OPTIONS.find((option) => option.value === props.type).labelKey),
);
function record() {
  open.value = false;
  return router.push('/fluid?entry=home');
}
// 5. VueJS Hooks
</script>
